import { useQueryParams } from "@/utils/useQueryParams";
import { format, addMonths } from "date-fns";
import { fr } from "date-fns/locale";
import { useState } from "react";
import Calendar from "react-calendar";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Box, Text, Button } from "@/ui";
import qs from "query-string";

export const FilterPeriodBox = () => {
  const theme = useTheme();
  const params = useQueryParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [periodVisible, setPeriodVisible] = useState(false);
  //@ts-ignore
  const currentPeriod = params.period ? new Date(Number(params.period)) : new Date();
  const now = new Date();
  const isCurrentMonth = currentPeriod.getFullYear() === now.getFullYear() && currentPeriod.getMonth() === now.getMonth();
  const periodLabel = format(currentPeriod, "MMMM yyyy", { locale: fr });

  const shiftPeriod = (months: number) => {
    const nextDate = addMonths(currentPeriod, months);
    const to = qs.stringify({ ...params, period: nextDate.getTime() }, { arrayFormat: "index" });
    navigate(`${location.pathname}?${to}`, { replace: true });
  };

  return (
    <Box width="100%" justifyContent="center" alignItems="center" mb={4} style={{ position: "relative" }}>
      <ChevronLeftIcon onClick={() => shiftPeriod(-1)} style={{ cursor: "pointer", color: theme.palette.primary.main, fontSize: 40 }} />
      <Box
        onClick={() => setPeriodVisible((v) => !v)}
        flexDirection="row"
        alignItems="center"
        style={{ cursor: "pointer", margin: "0 20px" }}
      >
        <Text fontSize={24} fontWeight="700" color={theme.palette.primary.main} style={{ textTransform: "capitalize" }}>
          {periodLabel}
        </Text>
        <ArrowDropDownIcon style={{ color: theme.palette.primary.main }} />
      </Box>
      <ChevronRightIcon
        onClick={() => !isCurrentMonth && shiftPeriod(1)}
        style={{
          cursor: isCurrentMonth ? "default" : "pointer",
          color: isCurrentMonth ? theme.palette.grey[300] : theme.palette.primary.main,
          fontSize: 40,
        }}
      />

      {periodVisible && (
        <Box
          style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            marginTop: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            backgroundColor: "#fff",
            boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
            borderRadius: "5px",
            overflow: "hidden",
            zIndex: 99999,
          }}
        >
          <Calendar
            maxDetail="year"
            onChange={(c) => {
              const p = new Date(c as any as string);
              const to = qs.stringify({ ...params, period: p.getTime() }, { arrayFormat: "index" });
              navigate(`${location.pathname}?${to}`, { replace: true });
              setPeriodVisible(false);
            }}
            maxDate={new Date()}
            value={currentPeriod}
          />
          <Box p={1}>
            <Button onClick={() => setPeriodVisible(false)}>Fermer</Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};
